import {
  PAGE_TAB_PARAM,
  CHAMP_PANEL_PARAMS,
  CUSTOMER_PANEL_PARAMS,
  parsePositiveId,
  useProfilePanelParams,
  useProfileTabParam,
} from "../profile/panel-params";

/**
 * The customer panel lives in the URL — `?customer=<id>` and, for the tab,
 * `&ctab=activity` — so it survives a reload, can be shared, and the browser's
 * Back closes it. The full page `/customers/:id` uses its own `ptab`.
 *
 * Opening pushes a history entry (Back closes the panel); closing replaces the
 * entry, so Back after closing goes to the page before it rather than
 * reopening the panel. Choosing a tab, or stepping to the next customer of a
 * list, replaces too: they are not places to go Back to. Opening a customer
 * closes a champ panel (one profile panel at a time) — see
 * `../profile/panel-params.ts`.
 */
export const CUSTOMER_PARAM = CUSTOMER_PANEL_PARAMS.param;
export const CUSTOMER_TAB_PARAM = CUSTOMER_PANEL_PARAMS.tabParam;

export const CUSTOMER_TABS = [
  "overview",
  "activity",
  "tickets",
  "whatsapp",
  "jobs",
  "calls",
] as const;
export type CustomerTab = (typeof CUSTOMER_TABS)[number];

export const parseCustomerId = parsePositiveId;

export function parseCustomerTab(value: string | null): CustomerTab | null {
  return (CUSTOMER_TABS as readonly string[]).includes(value ?? "")
    ? (value as CustomerTab)
    : null;
}

export { restoreOpener, rememberOpener } from "../profile/panel-params";

export function useCustomerPanel() {
  const { id, tab, open, close } = useProfilePanelParams<CustomerTab>(
    CUSTOMER_PANEL_PARAMS,
    CHAMP_PANEL_PARAMS,
    parseCustomerTab,
  );
  return { customerId: id, tab, open, close };
}

/** The tab on the full page (`/customers/:id`), which has no `customer` param. */
export function useCustomerTabParam() {
  return useProfileTabParam<CustomerTab>(PAGE_TAB_PARAM, parseCustomerTab);
}
